import { fromUnknownError } from '@citizen-walk/shared-types';

/**
 * AI 生成の callable (generateEcwDialogue / generateEcwTitleSuggestions / generateEcwInsightSummary)
 * の失敗を、参加者に見せる日本語の文にする。
 *
 * `permission-denied` (使えない地区・権限なし) と `resource-exhausted` (1 日の上限・呼出の上限) は
 * Functions が日本語の理由を message に入れて返すので、それをそのまま出す。それ以外 (内部エラー等) は
 * message が英語やコードのことがあるので、決まった文にする (内部の識別子を画面に出さない)。
 */
export function aiCallableErrorMessage(e: unknown): string {
  const raw = e as { code?: unknown; message?: unknown } | null;
  const code = typeof raw?.code === 'string' ? raw.code : '';
  const message = typeof raw?.message === 'string' ? raw.message.trim() : '';
  if (code.includes('unauthenticated')) return 'AI 生成には認証が必要です。';
  if (
    (code.includes('permission-denied') || code.includes('resource-exhausted')) &&
    message &&
    hasJapanese(message)
  ) {
    return message;
  }
  if (code.includes('resource-exhausted')) {
    return 'AI の利用が上限に達しました。しばらく経ってからもう一度お試しください。';
  }
  if (code.includes('permission-denied')) return 'この地区では AI の生成を使えません。';
  const err = fromUnknownError(e);
  if (err.message && hasJapanese(err.message)) return err.message;
  return 'AI の生成に失敗しました。もう一度お試しください。';
}

function hasJapanese(text: string): boolean {
  return /[\u3040-\u30ff\u3400-\u9fff]/.test(text);
}
